import EventHandler from './dom/event-handler';
import SelectorEngine from './dom/selector-engine';

class FocusTo {
    static changeFocus(selector) {
        SelectorEngine.findOne(selector).focus();
    }
}

const focusButtons = SelectorEngine.find('[data-ome-focus]');
for (const button of focusButtons) {
    EventHandler.on(SelectorEngine.findOne(button.dataset.bsTarget), 'shown.bs.collapse', () => {
        FocusTo.changeFocus(button.dataset.omeFocus);
    });
}

export default FocusTo;
